export default [
  {
    path: '/user',
    name: 'user',
    component: () => import('@/views/menu/user/user.vue'),
    meta: {
      pageTitle: 'کاربران',
      action: 'show',
      resource: 'UserManager',
    },
  },
  {
    path: '/userrole',
    name: 'userrole',
    component: () => import('@/views/menu/user/userrole.vue'),
    meta: {
      pageTitle: 'نقش ها',
      action: 'show',
      resource: 'UserRoleManager',
    },
  },
  {
    path: '/userrole/details',
    name: 'adduserrole',
    component: () => import('@/views/menu/user/userroledetails.vue'),
    meta: {
      pageTitle: 'ایجاد نقش',
      action: 'show',
      resource: 'UserRoleManager',
    },
  },
  {
    path: '/userrole/details/:id',
    name: 'updateuserrole',
    component: () => import('@/views/menu/user/userroledetails.vue'),
    meta: {
      pageTitle: 'ویرایش نقش',
      action: 'show',
      resource: 'UserRoleManager',
    },
  },
  {
    path: '/salary',
    name: 'salary',
    component: () => import('@/views/menu/user/salary.vue'),
    meta: {
      pageTitle: 'حکم های حقوقی',
      action: 'show',
      resource: 'SalaryManager',
    },
  },
  {
    path: '/salary/details',
    name: 'addsalary',
    component: () => import('@/views/menu/user/salarydetails.vue'),
    meta: {
      pageTitle: 'ایجاد حکم حقوقی',
      action: 'show',
      resource: 'SalaryManager',
    },
  },
  {
    path: '/salary/details/:id',
    name: 'updatesalary',
    component: () => import('@/views/menu/user/salarydetails.vue'),
    meta: {
      pageTitle: 'ویرایش حکم حقوقی',
      action: 'show',
      resource: 'SalaryManager',
    },
  },
  {
    path: '/usertransaction',
    name: 'usertransaction',
    component: () => import('@/views/menu/user/usertransaction.vue'),
    meta: {
      pageTitle: 'واریزها و بدهی ها',
      action: 'show',
      resource: 'UserTransactionManager',
    },
  },
  {
    path: '/userordercategoryprocess',
    name: 'userordercategoryprocess',
    component: () => import('@/views/menu/user/userordercategoryprocess.vue'),
    meta: {
      pageTitle: 'کارکردها',
      action: 'show',
      resource: 'SalaryManager',
    },
  },
  {
    path: '/pettycash',
    name: 'pettycash',
    component: () => import('@/views/menu/pettycash.vue'),
    meta: {
      pageTitle: 'تنخواه ها',
      action: 'show',
      resource: 'PettyCashManager',
    },
  },
]
